import React from 'react';

const Blog = () => {
    return (
        <div className='flex justify-center items-center h-[90vh]'>
            <h1 className='text-6xl'>Coming Soon</h1>
        </div>
    );
};

export default Blog;